import React, { useState, useEffect } from "react";
import moment from "moment";
import momentTz from "moment-timezone";
// import "moment/locale/da";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { textTranslate } from "../../utils/i18n";

// Add export module to highChart
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const ChartComp = (props) => {
  const { seriesData, chartResize } = props;
  const [chartConfig, setChartConfig] = useState({
    chart: {
      type: "area",
      zoomType: "x",
      panning: true,
      panKey: "shift",
      reflow: true,
      spacingTop: 30,
      height: props.height ? props.height : 150,
      scrollablePlotArea: {
        // minWidth: 600
      },
    },

    title: {
      text: " ",
    },
    subtitle: {
      text: " ",
    },

    yAxis: {
      title: {
        text: " ",
      },
    },

    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
    },
    xAxis: {
      type: "datetime",
      tickPixelInterval: 50,

      dateTimeLabelFormats: {
        millisecond: "%H:%M:%S.%L",
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b '%y",
        year: "%Y",
      },
    },
    series: [
      {
        dataGrouping: {
          enabled: false,
        },
      },
    ],
    time: {
      time: "",
      getTimezoneOffset: function (timestamp) {
        var zone = momentTz.tz.guess(),
          timezoneOffset = -moment.tz(timestamp, zone).utcOffset();

        return timezoneOffset;
      },
    },
    colors: ["#6CF", "#39F", "#06C", "#036", "#000"],
    // plotOptions: {
    //   series: {
    //     marker: {
    //       enabledThreshold: 5
    //     },
    //     events: { legendItemClick: this.handleLegendItemClick }
    //   }
    // },

    lang: {
      loading: "Aguarde...",
      months: moment.months(),
      weekdays: moment.weekdays(),
      shortMonths: moment.monthsShort(),
    },
  });

  useEffect(() => {
    let _newSerises = [];
    for (let deviceIndex = 0; deviceIndex < props.DevicesData.length; deviceIndex++) {
      // eslint-disable-next-line
      const seriesData = props.seriesesData[deviceIndex];
      let _data_arr = [];
      let _ref_arr = [];
      seriesData[0].forEach((dataReading) => {
        _data_arr.push([Date.parse(dataReading.ts), dataReading.v]);
      });
      _newSerises.push({
        name: textTranslate("chartData"),
        type: "column",
        data: _data_arr,
        color: "#20a8d8",
      });
      if (seriesData[1].length > 0) {
        seriesData[1].forEach((dataReading) => {
          _ref_arr.push([Date.parse(dataReading.ts), dataReading.v]);
        });
        _newSerises.push({
          name: textTranslate("chartRef"),
          type: "spline",
          data: _ref_arr,
          color: "#aaa",
        });
      }
    }
    setChartConfig({
      ...chartConfig,
      series: [..._newSerises],
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: getDateFormat(),
      },
      tooltip: {
        shared: true,
        crosshairs: [true, true],
        formatter: function () {
          return this.points.reduce(function (s, point) {
            return s + "<br/>" + point.series.name + ": <b> " + point.y + "</b>";
          }, " ");
        },
      },
    });
  }, [seriesData]);

  function getDateFormat() {
    switch (props.period.value) {
      case "day":
        return {
          hour: "%H:%M",
        };
      case "week":
        return {
          day: "%e. %b",
        };
      case "month":
        return {
          day: "%e. %b",
        };

      default:
        break;
    }
  }

  useEffect(() => {
    Highcharts.charts.forEach(chart => chart !== undefined && chart.reflow());
  }, [[], chartResize]);

  return (
    <React.Fragment>
      {!!chartConfig && (
        <React.Fragment>
          <HighchartsReact highcharts={Highcharts} options={chartConfig} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ChartComp;
